import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { MarkdownModule } from 'ngx-markdown';
import { CapitalLetterPipe } from 'src/app/shared/pipes/capital-letter.pipe';
import { CustomDatePipe } from 'src/app/shared/pipes/custom-date.pipe';
import { DateAgoPipe } from 'src/app/shared/pipes/date-ago.pipe';
import { DaysToMarketPipe } from 'src/app/shared/pipes/days.pipe';
import { AreYouSureDialogComponent } from './are-you-sure-dialog/are-you-sure-dialog.component';
import { CustomWarningModalComponent } from './custom-warning-modal/custom-warning-modal.component';
import { WarningModalComponent } from './warning-modal/warning-modal.component';
import { AppTabsComponent } from './app-tabs/app-tabs.component';
import { AppTableComponent } from './app-table/app-table.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { AppSelectComponent } from './app-select/app-select.component';

@NgModule({
  declarations: [
    DaysToMarketPipe,
    DateAgoPipe,
    CustomDatePipe,
    CapitalLetterPipe,
    WarningModalComponent,
    AreYouSureDialogComponent,
    CustomWarningModalComponent,
    AppTabsComponent,
    AppTableComponent,
    AppSelectComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MarkdownModule.forChild(),
    MatGridListModule,
    FormsModule,
    MatTooltipModule,
    NgSelectModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
  ],
  exports: [
    TranslateModule,
    MarkdownModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatGridListModule,
    MatTooltipModule,
    DaysToMarketPipe,
    DateAgoPipe,
    CapitalLetterPipe,
    CustomDatePipe,
    NgSelectModule,
    WarningModalComponent,
    MatDialogModule,
    AreYouSureDialogComponent,
    CustomWarningModalComponent,
    AppTabsComponent,
    AppTableComponent,
    AppSelectComponent,
    MatTableModule,
    MatPaginatorModule,
  ],
})
export class SharedModule {}
